import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function getNetworksApi() {
  return request(`${API_ROUTE}/networks`, {
    method: "GET",
  });
}

export async function editNetworksApi(id, body) {
  return request(`${API_ROUTE}/networks/${id}`, {
    method: "PUT",
    data: body,
  });
}

export async function addNetworksApi(body) {
  return request(`${API_ROUTE}/networks`, {
    method: "POST",
    data: body,
  });
}

export async function deleteNetworksApi(id) {
  return request(`${API_ROUTE}/networks/${id}`, {
    method: "DELETE",
  });
}
